module.exports = __webpack_public_path__ + "img/nt15-12-75-1.prt.3ba4c2da.jpg";